<template>
  <div>
    <h2>{{ user.first_name }} {{ user.last_name }}</h2>

    <hr v-if="user.first_name || user.employer_name">

    <div class="row my-4">
      <div class="col-lg-6 pr-5">
        <div class="input-group" style="max-width: 450px;">
          <select class="form-control" v-model="status">
            <option v-for="(statusOption, index) in statuses" :key="index">{{ statusOption }}</option>
          </select>
          <button class="btn btn-secondary" @click="updateStatus()">Update Status</button>
        </div>
      </div>
      <!-- <div class="col-lg-6 px-4">
        <div class="input-group">
          <multiselect v-model="tags" :options="tagsOptions" :multiple="true" :searchable="true" :close-on-select="false" :show-labels="false" placeholder="Select Tags"></multiselect>
          <button class="btn btn-secondary" @click="updateTags()" style="">Update Tags</button>
        </div>
      </div> -->
    </div>
    <hr>

    <div class="row my-4">
      <div class="col-lg-6 px-4">
        <h3>Notes</h3>
        <hr>
        <!-- {{ notes }} -->
        <div v-for="note in notes" :key="note.id">
          <!-- {{ note.note }} -->
          <pre @click="showEditNoteModal(note)" style="cursor: pointer;">{{ note.note }}</pre>
          <small style="">{{ (new Date(note.timestamp)).toDateString() }}<span v-if="note.type"> ({{ note.type }})</span></small>
          <hr>
        </div>
        <!-- <hr> -->
        <button class="mylisting-button dark-button" @click="showAddNoteModal()">Add Note</button>
      </div>
      <div class="col-lg-6 px-4">
        <p class="mb-3">Last Contacted Date: {{ new Date(user.last_contacted_date).toDateString() }}</p>
        <h3>Send Email</h3>
        <p class="mb-2">{{ user.email }}</p>
        <label style="margin-bottom: 0;">From Email</label>
        <input type="text" class="form-control mb-2" v-model="fromEmail" placeholder="From Email">
        <input type="text" class="form-control mb-2" v-model="emailSubject" placeholder="Subject">
        <textarea class="form-control" rows="5" v-model="emailMessage"></textarea>
        <div class="form-group form-check mb-1 mt-1">
          <input class="form-check-input" type="checkbox" :value="true" v-model="logMessage" style="">
          <label class="form-check-label" style="text-align: left; cursor: pointer;" @click="logMessage = !logMessage">
            Log email as note
          </label>
        </div>
        <button class="mylisting-button dark-button" style="" @click="sendEmail()">Send</button>
        <!-- <div v-if="user.phone">
          <h3 class="mt-5">Send SMS</h3>
          <p class="mb-2">{{ user.phone }}</p>
          <textarea class="form-control" rows="3" v-model="textMessage"></textarea>
          <div class="form-group form-check mb-1 mt-1">
            <input class="form-check-input" type="checkbox" :value="true" v-model="logMessage" style="">
            <label class="form-check-label" style="text-align: left; cursor: pointer;" @click="logMessage = !logMessage">
              Log SMS as note
            </label>
          </div>
          <button class="mylisting-button dark-button" style="" @click="sendSMS()">Send</button>
        </div> -->

      </div>
    </div>

    <hr>
    <!-- <button class="mylisting-button dark-button" @click="updatePassword()">Update Password</button> -->
    <!-- <button class="mylisting-button dark-button" @click="showAddNoteModal()">Update Password</button> -->
    <div class="input-group" style="max-width: 450px;">
      <input class="form-control" v-model="password">
      <button class="btn btn-secondary" @click="updatePassword()">Update Password</button>
    </div>

    <modal name="note-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2 v-if="!note.id">Add Note</h2>
        <h2 v-if="note.id">Edit Note</h2>
        <hr>
        <textarea class="form-control" rows="5" v-model="noteText"></textarea>
        <hr>
        <button class="mylisting-button secondary-button" @click="hideNoteModal()" style="">Cancel</button>
        <button v-if="note.id" class="mylisting-button danger-button" @click="deleteNote()" style="">Delete Note</button>
        <!-- <button class="mylisting-button dark-button" @click="resetPassword(user)" style="">Reset Password</button> -->
        <!-- <button class="btn btn-danger" @click="deleteUser(user)">Delete</button> -->
        <!-- <button v-if="user.status != 'Active'" class="mylisting-button dark-button" @click="approveUser(user)" style="float: right;">Activate</button> -->
        <button v-if="!note.id" class="mylisting-button dark-button" @click="addNote()" style="float: right;">Add Note</button>
        <button v-if="note.id" class="mylisting-button dark-button" @click="updateNote()" style="float: right;">Update Note</button>
        <!-- <button class="mylisting-button danger-button" @click="deleteUser(user)">Delete</button> -->

      </div>
    </modal>

    <modal name="message-sent-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Message sent.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('message-sent-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="status-updated-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Status updated.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('status-updated-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="password-reset-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Password reset to {{ this.password }}</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('password-reset-modal')" style="">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  props: ['passedUser'],
  data() {
    return {
      agency: {},

      user: {},
      status: '',
      statuses: [],
      tags: [],
      tagsOptions: [],

      notes: [],
      note: {},
      noteText: '',
      noteType: '',

      fromEmail: '',
      emailSubject: "",
      emailMessage: "",
      textMessage: "",
      logMessage: true,

      password: '',
    }
  },
  created() {
    this.user = this.passedUser

    if (this.user.is_candidate) {
      this.statuses = this.$store.getters.candidateStatuses
    }

    if (this.user.is_employer) {
      this.statuses = this.$store.getters.employerStatuses
    }

    this.getNotes()
    this.fromEmail = this.$store.getters.agencyFromEmail
    this.status = this.user.status
    this.tagsOptions = this.$store.getters.focusAreas
    this.tags = this.user.sectors

    this.getAgency()
  },
  methods: {
    getAgency() {
      // axios.get()
    },
    // updateStatus() {
    //   axios.patch('/api/people/'+this.user.id+'/', {
    //     status: this.status
    //   })
    //     .then(res => {
    //       this.user.status = this.status
    //       this.$emit('userUpdated') // Lecture 112

    //       if (this.status == 'Application Approved') {
    //         console.log('Application approved!')
    //         // Send client email to access the dashboard
    //         this.$store.dispatch('sendEmail',
    //           {
    //             subject: 'Welcome to The Nanny Company',
    //             message: 'Hello ' + this.user.first_name + ' & ' + this.user.features[0] + ',\n\n' +
    //             'Thank you for contacting us! We would be glad to help you find a Nanny for your family.\n\n' +
    //             'The next step in this process is to set up an In-Home interview, in which we personally come over, meet the parents and children and to discuss your needs and expectations. We do ask for a minimum 4-6 weeks from the date of the In-home Interview, though we will do our best to place you with someone as soon as possible.\n\n' +
    //             'To set up the interview please access your client dashboard by visiting: https://goldcoastnannies.enginehire.io/login \n' +
    //             'Your username and password is your email address, please change your password once you have logged in.\n\n' +
    //             'Please don\'t hesitate to reach out if you have any questions or issues. We are looking forward to working with your family and are honored you\'ve chosen us!\n\n' +
    //             'Thank you,\n'+
    //             'The Nanny Company Team',
    //             from: this.$store.getters.agencyFromEmail,
    //             email: this.$store.getters.enginehireAdminEmail,
    //             reply: this.$store.getters.agencyReplyEmail,
    //             // userID: this.aakashid,
    //             userID: 4,
    //           }
    //         )
    //       }
    //       else {
    //         console.log('hmmmmmm')
    //       }

    //     })
    // },
    updateTags() {
      axios.patch('/api/people/'+this.user.id+'/', {
        sectors: this.tags
      })
        .then(res => {
          this.user.sectors = this.tags
          this.$emit('userUpdated') // Lecture 112
        })
    },
    getNotes() {
      axios.get('/api/notes?user='+this.user.id)
        .then(res => {
          this.notes = res.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    showAddNoteModal() {
      this.note = {}
      this.noteText = ''
      this.$modal.show('note-modal')
    },
    showEditNoteModal(note) {
      this.note = note
      this.noteText = note.note
      this.$modal.show('note-modal')
    },
    hideNoteModal() {
      this.note = {}
      this.noteText = ''
      this.$modal.hide('note-modal')
    },
    addNote() {
      console.log(this.user.id)
      console.log(this.$store.getters.userID)
      console.log(this.noteText)
      console.log(this.$store.getters.agencyName)
      console.log(this.$store.getters.agencyID)

      axios.post('/api/notes/', {
        user: this.user.id,
        enterer: this.$store.getters.userID,
        note: this.noteText,
        type: this.noteType,
        agency_owner: this.$store.getters.agencyName,
        agency: this.$store.getters.agencyID,
      })
        .then(res => {
          console.log(res)
          this.hideNoteModal()
          this.getNotes()
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateNote() {
      axios.patch('/api/notes/'+this.note.id+'/', {
        note: this.noteText,
      })
        .then(res => {
          console.log(res)
          this.hideNoteModal()
          this.getNotes()
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteNote() {
      axios.delete('/api/notes/'+this.note.id+'/')
        .then(res => {
          console.log(res)
          this.hideNoteModal()
          this.getNotes()
        })
        .catch(error => {
          console.log(error)
        })
    },
    sendEmail() {
      this.$modal.show('message-sent-modal')

      axios
        .post("/optimum/email/", {
          subject: this.emailSubject,
          message: this.emailMessage,
          from_address: this.fromEmail,
          to_address: this.user.email,
          reply_address: this.fromEmail,
          user_id: this.user.id
        })
        .then(res => {
          console.log(res);
          this.user.last_contacted_date = new Date()

          if (this.logMessage) {
            this.noteType = 'Email'
            this.noteText = 'Subject: ' + this.emailSubject + '\n\n' + this.emailMessage
            this.addNote()
            this.emailSubject = ''
            this.emailMessage = ''
          }
          else {
            this.emailSubject = ''
            this.emailMessage = ''
          }
        })
        .catch(error => console.log(error));
      // }
    },
    sendSMS() {
      this.$modal.show('message-sent-modal')

      axios
        .post("/optimum/message/", {
          message: this.textMessage,
          phone: this.user.phone,
          user_id: this.user.id
        })
        .then(res => {
          console.log(res);
          this.user.last_contacted_date = new Date()

          if (this.logMessage) {
            this.noteType = 'SMS'
            this.noteText = this.textMessage
            this.addNote()
            this.textMessage = ''
          }
          else {
            this.textMessage = ''
          }
        })
        .catch(error => console.log(error));
    },
    updateStatus() {
      axios.patch('/api/people/'+this.user.id+'/', {
        status: this.status
      })
        .then(res => {
          this.user.status = this.status
          this.$emit('userUpdated') // Lecture 112

          this.$modal.show('status-updated-modal')

          let selector1 = ''
          if (this.user.is_candidate) {
            // selector1 = 'Candidate'
            selector1 = 'Nanny'
          }
          else if (this.user.is_employer) {
            selector1 = 'Employer'
          }
          // let agencyEmail = this.$store.getters.agencyAdminEmail
          // if (this.user.is_candidate) {
          //   agencyEmail = this.$store.getters.agencyAdminEmail3
          // }
          axios.get(`/api/emailtemplates/?agency=${this.$store.getters.agencyID}&status=${this.status}&type=Status Change Notification&selector1=${selector1}`) // Get the email template corresponding to the new status
            .then(res => {
              console.log(res)
              if (res.data.length) { // If there is an email template for this new status
                let emailTemplate = res.data[0]

                // let agencyEmail = ''
                // if (emailTemplate.from_email) {
                //   agencyEmail = emailTemplate.from_email
                // } else {
                //   agencyEmail = this.$store.getters.agencyAdminEmail
                //   if (this.user.is_candidate) {
                //     agencyEmail = this.$store.getters.agencyAdminEmail3
                //   }
                // }
                // console.log(agencyEmail)
                let agencyEmail = this.$store.getters.agencyFromEmail

                console.log(emailTemplate)
                // if (emailTemplate.type == 'Status Change Notification') { // If the email template triggers on
                  this.$store.dispatch('sendEmails', {
                    subject: emailTemplate.subject,
                    message: emailTemplate.body.replace('[*fname*]', this.user.first_name).replace('[[fname]]', this.user.first_name), // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/replace
                    // from: this.$store.getters.agencyFromEmail,
                    from: agencyEmail,
                    // emails: [this.$store.getters.enginehireAdminEmail, this.user.email],
                    emails: [this.$store.getters.enginehireLoggingEmail, this.user.email],
                    // reply: this.$store.getters.agencyReplyEmail,
                    reply: agencyEmail,
                    userID: this.user.id,
                  })
                // }
              }
            })
            .catch(error => console.log(error))

          if (this.user.is_candidate) {
            selector1 = 'Candidate'
          }

          // Get any document templates that trigger on a change to this status
          axios.get(`/api/documenttemplates/?agency=${this.$store.getters.agencyID}&status_trigger=${this.status}&type=${selector1}`)
            .then(res => {
              console.log(res)
              let templates = res.data
              for (var template in templates) {
                axios.post('/api/documents/', {
                  template: templates[template].id,
                  title: templates[template].name,
                  signing_user: this.user.id,
                  status: 'Unsigned',
                  body: templates[template].body,
                  fields_labels: templates[template].fields,
                  fields_required: templates[template].fields_required,
                  edit_access: templates[template].edit_access,
                  organization_signer: templates[template].organization_signer,
                  signer_labels: templates[template].signer_labels,
                  agency_owner: this.$store.getters.agencyName,
                  agency: this.$store.getters.agencyID,
                })
                  .then(res => { console.log(res) })
                  .catch(error => { console.log(error) })
              }
            })
            .catch(error => console.log(error))

          if (this.user.is_employer) {
            if (this.status == 'Application Approved') {
              // console.log('Application approved!')
              // console.log(this.user)
              // console.log(this.user.selector1)

              // Send client email to access the dashboard
              // this.$store.dispatch('sendEmails',
              //   {
              //     subject: 'Welcome to Coast to Coast Nannies',
              //     message: 'Hello ' + this.user.first_name + ',\n\n' +
              //     'Thank you for contacting us! We would be glad to help you find a Nanny for your family.\n\n' +
              //     'The next step in this process is to access your client dashboard by visiting: https://goldcoastnannies.enginehire.io/login \n' +
              //     'Your username and password is your email address, please change your password once you have logged in.\n\n' +
              //     'Once you have logged in you will see an option to pay the start up fee, at which point we will begin presenting you with nannies!\n' +
              //     'Please don\'t hesitate to reach out if you have any questions or issues. We are looking forward to working with your family!\n\n' +
              //     'Thank you,\n'+
              //     'The Coast to Coast Nannies Team',
              //     from: this.$store.getters.agencyFromEmail,
              //     emails: [this.$store.getters.enginehireAdminEmail, this.user.email],
              //     reply: this.$store.getters.agencyReplyEmail,
              //     // userID: this.aakashid,
              //     userID: this.user.id,
              //   }
              // )

              // axios.get(`/api/documents/?signing_user=${this.user.id}&title=Client Agency Agreement`)
              //   .then(res => {
              //     console.log(res)
              //     if (!res.data.length) { // If the document doesn't already exist, we need to create it
              //       // console.log(this.$store.getters.transportationConsent)
              //       axios.post('/api/documents/', {
              //         title: 'Client Agency Agreement',
              //         signing_user: this.user.id,
              //         // signing_name: `${this.user.first_name} ${this.user.last_name}`,
              //         signing_name_secondary: 'Sarah Meadors',
              //         status: 'Unsigned',
              //         field1: `${this.user.first_name} ${this.user.last_name}`,
              //         field2: '',
              //         field3: `${this.user.email}`,
              //         body: this.$store.getters.familyAgencyContract,
              //         agency_owner: this.$store.getters.agencyName,
              //         agency: this.$store.getters.agencyID,
              //       })
              //         .then(res => { console.log(res) })
              //         .catch(error => { console.log(error) })
              //     }
              //   })
              //   .catch(error => console.log(error))
            }
            else if (this.status == 'Interview Complete') {
              // Create a list of all the children
              // let children = this.user.features2[0]
              // if (this.user.features2[2]) { children += `, ${this.user.features2[2]}` }
              // if (this.user.features2[4]) { children += `, ${this.user.features2[4]}` }
              // if (this.user.features2[6]) { children += `, ${this.user.features2[6]}` }

              // axios.get(`/api/documents/?signing_user=${this.user.id}&title=Transportation Consent`)
              //   .then(res => {
              //     console.log(res)
              //     if (!res.data.length) { // If the document doesn't already exist, we need to create it
              //       // console.log(this.$store.getters.transportationConsent)
              //       axios.post('/api/documents/', {
              //         title: 'Transportation Consent',
              //         signing_user: this.user.id,
              //         status: 'Unsigned',
              //         field1: `${this.user.first_name} ${this.user.last_name} & ${this.user.features[0]} ${this.user.features[1]}`,
              //         field2: children,
              //         body: this.$store.getters.transportationConsent,
              //         agency_owner: this.$store.getters.agencyName,
              //         agency: this.$store.getters.agencyID,
              //       })
              //         .then(res => { console.log(res) })
              //         .catch(error => { console.log(error) })
              //     }
              //   })

              // axios.get(`/api/documents/?signing_user=${this.user.id}&title=Use of Client Vehicle`)
              //   .then(res => {
              //     console.log(res)
              //     if (!res.data.length) { // If the document doesn't already exist, we need to create it
              //       // console.log(this.$store.getters.transportationConsent)
              //       axios.post('/api/documents/', {
              //         title: 'Use of Client Vehicle',
              //         signing_user: this.user.id,
              //         signing_name_secondary: 'Danica Charriere',
              //         signing_date_secondary: this.todayDatetimeDjangoFormat,
              //         status: 'Unsigned',
              //         field1: `${this.user.first_name} ${this.user.last_name} & ${this.user.features[0]} ${this.user.features[1]}`,
              //         // field2: children,
              //         body: this.$store.getters.useofClientVehicle,
              //         agency_owner: this.$store.getters.agencyName,
              //         agency: this.$store.getters.agencyID,
              //       })
              //         .then(res => { console.log(res) })
              //         .catch(error => { console.log(error) })
              //     }
              //   })

              // axios.get(`/api/documents/?signing_user=${this.user.id}&title=Transport with Employee Vehicle`)
              //   .then(res => {
              //     console.log(res)
              //     if (!res.data.length) { // If the document doesn't already exist, we need to create it
              //       // console.log(this.$store.getters.transportationConsent)
              //       axios.post('/api/documents/', {
              //         title: 'Transport with Employee Vehicle',
              //         signing_user: this.user.id,
              //         signing_name_secondary: 'Danica Charriere',
              //         signing_date_secondary: this.todayDatetimeDjangoFormat,
              //         status: 'Unsigned',
              //         field1: `${this.user.first_name} ${this.user.last_name} & ${this.user.features[0]} ${this.user.features[1]}`,
              //         // field2: children,
              //         body: this.$store.getters.useofClientVehicle,
              //         agency_owner: this.$store.getters.agencyName,
              //         agency: this.$store.getters.agencyID,
              //       })
              //         .then(res => { console.log(res) })
              //         .catch(error => { console.log(error) })
              //     }
              //   })

              // axios.get(`/api/documents/?signing_user=${this.user.id}&title=Medical Release`)
              //   .then(res => {
              //     console.log(res)
              //     if (!res.data.length) { // If the document doesn't already exist, we need to create it
              //       for (var x=0; x < this.user.features2.length; x += 2) {
              //         if (this.user.features2[x]) {
              //           axios.post('/api/documents/', {
              //             title: 'Medical Release',
              //             signing_user: this.user.id,
              //             status: 'Unsigned',
              //             field1: `${this.user.features2[x]}`,
              //             field2: `${this.user.features2[x+1]}`,
              //             body: this.$store.getters.medicalRelease,
              //             agency_owner: this.$store.getters.agencyName,
              //             agency: this.$store.getters.agencyID,
              //           })
              //             .then(res => { console.log(res) })
              //             .catch(error => { console.log(error) })
              //         }
              //       }
              //     }
              //   })
            }
          }
          if (this.user.is_candidate) {
            if (this.status == 'Application Approved') {
              console.log('Application approved!')
              console.log(this.user)
              // Send nanny email to access the dashboard
              // this.$store.dispatch('sendEmails',
              //   {
              //     subject: 'Thank you for applying to Coast to Coast Nannies',
              //     message: 'Hello ' + this.user.first_name + ',\n\n' +
              //     'Thank you for your application! \n' +
              //     'We have reviewed it and would like to schedule an interview with you, which you can do by visiting: https://calendly.com/sarah-goldcoastnannies/30min \n\n' +
              //     // 'Your username and password is your email address, please change your password once you have logged in.\n\n' +
              //     // 'Once you have logged in you will see an option to pay the start up fee, at which point we will begin presenting you with nannies!\n' +
              //     'Please don\'t hesitate to reach out if you have any questions or issues. We are looking forward to meeting you!\n\n' +
              //     'Thank you,\n'+
              //     'The Coast to Coast Nannies Team',
              //     from: this.$store.getters.agencyFromEmail,
              //     emails: [this.$store.getters.enginehireAdminEmail, this.user.email],
              //     reply: this.$store.getters.agencyReplyEmail,
              //     // userID: this.aakashid,
              //     userID: this.user.id,
              //   }
              // )
            }
            else if (this.status == 'Rejected') {
              console.log('Application approved!')
              console.log(this.user)
              // Send nanny email to access the dashboard
              // this.$store.dispatch('sendEmails',
              //   {
              //     subject: 'Thank you for applying to Coast to Coast Nannies',
              //     message: 'Hello ' + this.user.first_name + ',\n\n' +
              //     'Thank you for expressing interest in working with Coast to Coast Nannies. At this time we have decided to move forward with other candidates. Best of luck in your search! \n\n' +
              //     // 'We have reviewed it and would like to schedule an interview with you, which you can do by visiting: https://calendly.com/sarah-goldcoastnannies/30min \n\n' +
              //     // 'Your username and password is your email address, please change your password once you have logged in.\n\n' +
              //     // 'Once you have logged in you will see an option to pay the start up fee, at which point we will begin presenting you with nannies!\n' +
              //     // 'Please don\'t hesitate to reach out if you have any questions or issues. We are looking forward to meeting you!\n\n' +
              //     'Thank you,\n'+
              //     'The Coast to Coast Nannies Team',
              //     from: this.$store.getters.agencyFromEmail,
              //     emails: [this.$store.getters.enginehireAdminEmail, this.user.email],
              //     reply: this.$store.getters.agencyReplyEmail,
              //     // userID: this.aakashid,
              //     userID: this.user.id,
              //   }
              // )
            }
            else if (this.status == 'Interview Complete') {
              axios.get(`/api/documents/?signing_user=${this.user.id}&title=Code of Conduct`)
                .then(res => {
                  console.log(res)
                  if (!res.data.length) { // If the document doesn't already exist, we need to create it
                    // console.log(this.$store.getters.transportationConsent)
                    axios.post('/api/documents/', {
                      title: 'Code of Conduct',
                      signing_user: this.user.id,
                      // signing_name: `${this.user.first_name} ${this.user.last_name}`,
                      status: 'Unsigned',
                      // field1: `${this.user.first_name} ${this.user.last_name} & ${this.user.features[0]} ${this.user.features[1]}`,
                      // field2: children,
                      // body: this.$store.getters.transportationConsent,
                      agency_owner: this.$store.getters.agencyName,
                      agency: this.$store.getters.agencyID,
                    })
                      .then(res => { console.log(res) })
                      .catch(error => { console.log(error) })
                  }
                })

              axios.get(`/api/documents/?signing_user=${this.user.id}&title=Background Check`)
                .then(res => {
                  console.log(res)
                  if (!res.data.length) { // If the document doesn't already exist, we need to create it
                    // console.log(this.$store.getters.transportationConsent)
                    axios.post('/api/documents/', {
                      title: 'Background Check',
                      signing_user: this.user.id,
                      // signing_name: `${this.user.first_name} ${this.user.last_name}`,
                      status: 'Unsigned',
                      field1: `${this.user.first_name} ${this.user.last_name}`,
                      field2: '',
                      field3: '',
                      field4: '',
                      field5: this.user.city,
                      field6: this.user.provincestate,
                      field7: this.user.postal_code,
                      field8: this.user.selector6,
                      field9: '',
                      // body: this.$store.getters.transportationConsent,
                      agency_owner: this.$store.getters.agencyName,
                      agency: this.$store.getters.agencyID,
                    })
                      .then(res => { console.log(res) })
                      .catch(error => { console.log(error) })
                  }
                })
                .catch(error => console.log(error))
            }
          }
        })
    },
    updatePassword() {
      axios.post('/optimum/manual-reset-password/', {
        user_id: this.user.id,
        password: this.password,
      })
        .then(res => {
          console.log(res)
          this.$modal.show('password-reset-modal')
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/agents/Panel.vue